'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessToken = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = require('./core');

var _authCache = require('../helpers/authCache');

var _authCache2 = _interopRequireDefault(_authCache);

var _promise = require('../helpers/promise');

var _index = require('../index');

var _userInfo = require('../userInfo');

var _hubapi = require('./hubapi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accessTokenInfo = function accessTokenInfo(portalId, accessToken) {
  return {
    portalId: portalId,
    token: accessToken.token,
    expiresAt: accessToken.expires_at
  };
};

var getAccessToken = function getAccessToken(options) {
  var cachedInfo = _authCache2.default.get(options);

  if (!cachedInfo.token || cachedInfo.expiresAt && new Date() - new Date(cachedInfo.expiresAt) > 0) {
    return (0, _userInfo.userInfoWithDelegatedOptions)(_extends({}, options, {
      refreshOnExpiredToken: true
    })).then(function (_ref) {
      var auth = _ref.auth;

      var newInfo = accessTokenInfo(options.portalId, auth.access_token);
      _authCache2.default.set(options, newInfo);
      return newInfo;
    });
  }
  return _promise.Promise.resolve(cachedInfo);
};

var accessTokenQueryString = function accessTokenQueryString(options) {
  return getAccessToken(options).then(function (info) {
    return (0, _core.query)({ access_token: info.token })(options);
  });
};

var accessToken = exports.accessToken = (0, _index.createStack)(_hubapi.logoutOnMissingPortalId, accessTokenQueryString);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.117/js/middlewares/accessTokenAuth.js
// module id = 319
// module chunks = 0 1